import { Component, Input } from '@angular/core';
import { User } from '../../../core/models/user.model';
import { TitleCasePipe } from '@angular/common';
import { ReplacePipe } from '../../../shared/pipes/replace.pipe';
import { UserStatus } from 'app/core/enums/user-status.enum';

@Component({
  selector: 'app-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.scss'],
  imports: [TitleCasePipe, ReplacePipe]
})
export class UserHeaderComponent {
  @Input() user: User;

  userStatuses = UserStatus;

  constructor() {}
}
